import { registerModule } from '../../core/module.js';
import { Receive, Adjust, StockCount } from './Stock.js';

/** Receiving a shipment, adjusting stock, and counting the shelves. */
export default registerModule({
  id: 'stock',
  order: 40,
  nav: [
    { to: '/receive', labelKey: 'nav.receive', icon: '📦', group: 'stock', permission: 'stock.receive', order: 2, hintKey: 'nav.hintReceive' },
    { to: '/adjust', labelKey: 'nav.adjust', icon: '✏', group: 'stock', permission: 'stock.adjust', order: 3, hintKey: 'nav.hintAdjust' },
    { to: '/stock-count', labelKey: 'nav.stockCount', icon: '📋', group: 'stock', permission: 'stock.count', order: 4, hintKey: 'nav.hintStockCount' },
  ],
  routes: [
    { path: '/receive', element: <Receive />, permission: 'stock.receive', titleKey: 'stock.receive' },
    { path: '/adjust', element: <Adjust />, permission: 'stock.adjust', titleKey: 'stock.adjust' },
    { path: '/stock-count', element: <StockCount />, permission: 'stock.count', titleKey: 'stock.count' },
  ],
});
